export enum PreferenceViewEnum {
    UnreadNotifications = 0,
    AllNotifications = 1
}

export enum StepRenderNotificationsEnum {
    Read = 0,
    Settings = 1
}
